import { Filter } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SurveyFiltersProps {
  onFilterChange: (status: string | null) => void;
  currentFilter: string | null;
}

export function SurveyFilters({ onFilterChange, currentFilter }: SurveyFiltersProps) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 mb-6">
      <div className="flex items-center flex-wrap gap-3">
        <div className="flex items-center mr-2">
          <Filter className="h-5 w-5 text-blue-500 dark:text-blue-400 mr-2" />
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Filter by:</span>
        </div>
        
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => onFilterChange(null)}
            className={cn(
              "inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-colors",
              currentFilter === null
                ? "bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-300"
                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
            )}
          >
            All Surveys
          </button>
          
          <button
            onClick={() => onFilterChange('draft')}
            className={cn(
              "inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-colors",
              currentFilter === 'draft'
                ? "bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-300"
                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
            )}
          >
            Draft
          </button>
          
          <button
            onClick={() => onFilterChange('published')}
            className={cn(
              "inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-colors",
              currentFilter === 'published'
                ? "bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-300"
                : "bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
            )}
          >
            Published
          </button>
        </div>
      </div>
    </div>
  );
}